module.exports = __webpack_public_path__ + "img/lens-160-minus-07.04d0fd91.png";